import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { myPageService } from 'shared/src/api/myPageService';

export const useDeletePoc = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sno: number) => myPageService.deletePoc(sno),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKey.pocList() });
    },
  });
};
